import React, { useEffect, useMemo, useState, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import {
  Container,
  Flex,
  Image,
  Box,
  List,
  ListItem,
  Link,
  Input,
  Select,
  Button,
  Text,
} from "@chakra-ui/react";
import logoWhite from "../img/Welltower-Logo-white.svg";
import logo from "../img/Welltower-Logo-Pantone.svg";
import MenuImg from "../img/menu-bg.png";
import useScrollPosition from "../hooks/useScroll";
import { LocateIcon } from "./Icons";
import PlacesAutocomplete from "react-places-autocomplete";
// TODO - Switch to https://tomchentw.github.io/react-google-maps/#searchbox to match map?
import ButtonTheme from "./ButtonTheme";

const HeaderMenu = [
  {
    id: 0,
    title: "Home",
    link: "/",
    newTab: false,
  },
  {
    id: 1,
    title: "Properties",
    link: "/property",
    newTab: false,
  },
  {
    id: 2,
    title: "Portfolio",
    link: "/portfolio",
    newTab: false,
  },
  {
    id: 3,
    title: "Perspective",
    link: "/perspective",
    newTab: false,
  },
  {
    id: 4,
    title: "Who We Are",
    link: "/who-we-are",
    newTab: false,
  },
  {
    id: 5,
    title: "What We Do",
    link: "/what-we-do",
    newTab: false,
  },
  {
    id: 6,
    title: "Current Tenants",
    link: "/current-tenants",
    newTab: false,
  },
  {
    id: 7,
    title: "WELL (NYSE)",
    link: "https://www.welltower.com",
    newTab: true,
  },
];

const NewHeader = ({ isDarkBackground, searchOption }) => {
  const topPageRef = React.useRef(null);
  const [headerScroll, setHeaderScroll] = useState(false);
  const [hamburger, sethamburger] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [min, setMin] = useState("");
  const [max, setMax] = useState("");
  const [availability, setAvailability] = useState("");
  const [spaceCondition, setSpaceCondition] = useState("");
  const [searchCenter, setSearchCenter] = useState(null);
  const [open, setOpen] = useState(false);
  const scrollPosition = useScrollPosition();
  // const router = useRou
  useEffect(() => {
    console.log(open);
  }, [open]);
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const address =
    searchParams.get("address") === "null" ? "" : searchParams.get("address") || "";
  useEffect(() => {
    /* if (topPageRef.current) {
      topPageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    */
  }, [location]);
  useEffect(() => {
    setTimeout(() => {
      /*if (topPageRef.current) {
        topPageRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }*/
    }, 1000);
    setMin(searchParams.get("min"));
    setMax(searchParams.get("max"));
    setAvailability(searchParams.get("availability"));
    setSpaceCondition(searchParams.get("spaceCondition"));
    // setAvailability(searchParams.get(""));
    // TODO move Further to its own useEffect
    // TODO add an env var to turn off failing Further load on local testing
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.async = true;
    script.src =
      ("https:" === document.location.protocol ? "https://" : "http://") +
      "js.talkfurther.com/talkfurther_init.min.js";

    document.head.appendChild(script);

    // Cleanup the script when the component is removed
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (scrollPosition >= 100) {
      setHeaderScroll(true);
      sethamburger(false);
    } else {
      setHeaderScroll(false);
    }
  }, [scrollPosition]);

  useEffect(() => {
    setSearchQuery(address || "");
  }, [address]);

  useEffect(() => {
    if (searchOption)
      history.push(
        `/search?address=${address}&min=${min}&max=${max}&spaceCondition=${spaceCondition}`
      );
  }, [min, max, searchOption, availability, spaceCondition, address, history]);

  const handleLocateIconClick = () => {
    // Attempt to get the user's current location
    history.push(`/search?address=&min=&max=&spaceCondition=`);
    if (navigator.geolocation) {
      /*navigator.geolocation.getCurrentPosition(
        (position) => {
          const ll = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setSearchCenter(ll); // Update the center of the map


        },
        (error) => {
          console.error("Error fetching user location:", error);
        }
      );

      */
    } else {
      console.warn("Geolocation is not supported by this browser.");
    }
  };

  const squareFootage = () => {
    if (min && max && min !== "null" && max !== "null")
      return (
        (parseFloat(min) / 1000).toFixed(2) +
        "K - " +
        (parseFloat(max) / 1000).toFixed(2) +
        "K SF"
      );
    else return "Square Footage";
  };

  const gototenant = () => {
    window.location.href = "https://tenant.welltower.com";
  };

  const resetSearch = () => {
    setSpaceCondition("");
    setMax("");
    setMin("");
    setOpen(false);
  };
  const handleFormSubmit = (address, event) => {
    setSearchQuery(address);

    history.push(
      `/search?address=${address}&min=${min}&max=${max}&spaceCondition=${spaceCondition}`
    );
  };
  return (
    <>
      <div ref={topPageRef}></div>
      <Box
        as="header"
        w={"100%"}
        position={"fixed"}
        top={"0"}
        bgColor={
          headerScroll ? `rgba(19, 76, 106, ${hamburger ? "0" : "0.6"} )` : ""
        }
        transition={"ease all .5s"}
        py={headerScroll ? 3 : 6}
        zIndex={999}
        backdropFilter={headerScroll ? "blur(8px)" : ""}
      >
        <Container maxW={"95%"}>
          <Flex gap={8} justifyContent={"space-between"} alignItems={"center"}>
            <Link href="/">
              <Image
                src={
                  isDarkBackground || hamburger || headerScroll
                    ? logoWhite
                    : logo
                }
                w={{ md: 40, base: "115px" }}
                // h={"48px"}
              />
            </Link>
            {searchOption && (
              <Flex
                justifyContent={"center"}
                flex={1}
                // display={{ lg: "flex", base: "none" }}
                pos={{ lg: "relative", base: "absolute" }}
                w={{ lg: "50%", base: "100%" }}
                gap={{ lg: 4, base: 0 }}
                opacity={hamburger ? 0 : 1}
                bottom={{ lg: 0, base: "-40px" }}
                left={0}
                right={0}
              >
                <Box h={"40px"} pos={"relative"} w={{ lg: "50%", base: "70%" }}>
                  <PlacesAutocomplete
                    value={searchQuery}
                    onChange={(value) => setSearchQuery(value)}
                    onSelect={(address) => handleFormSubmit(address)}
                  >
                    {({
                      getInputProps,
                      suggestions,
                      getSuggestionItemProps,
                    }) => (
                      <div className="googleresults">
                        <Input
                          {...getInputProps({
                            placeholder: "Search Places ...",
                            borderRadius: { lg: "20px", base: 0 },
                            border: "1px solid",
                            borderLeft: { lg: "1px solid", base: 0 },
                            borderRight: { lg: "1px solid", base: 0 },
                            borderColor: "DarkBlue",
                            background: "white",
                          })}
                        />
                        <Box
                          sx={{
                            ".googleresult": {
                              _hover: {
                                color: "white",
                                bgColor: "BrightTurquoise",
                                cursor: "pointer",
                              },
                            },
                          }}
                        >
                          {suggestions.map((suggestion) => (
                            <Box
                              className="googleresult"
                              {...getSuggestionItemProps(suggestion)}
                              key={suggestion.description}
                            >
                              {suggestion.description}
                            </Box>
                          ))}
                        </Box>
                      </div>
                    )}
                  </PlacesAutocomplete>

                  <LocateIcon
                    pos={"absolute"}
                    top={"50%"}
                    // margin={"-4px"}
                    right={"10px"}
                    transform={"translateY(-50%)"}
                    zIndex={1}
                    cursor="pointer"
                    onClick={handleLocateIconClick}
                  />
                </Box>
                <Box pos={"relative"} w={{ lg: "auto", base: "30%" }}>
                  <Button
                    display={{ lg: "flex", base: "none" }}
                    justifyContent={"space-between"}
                    borderRadius={{ lg: "20px", base: 0 }}
                    textTransform={"math-auto"}
                    border={"1px solid"}
                    borderColor={"DarkBlue"}
                    fontWeight={"400"}
                    bgColor={"white"}
                    onClick={() => setOpen(!open)}
                    width={{ lg: "222px", base: "100%" }}
                  >
                    {squareFootage()}
                    <div className="arrow-down">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="7"
                        viewBox="0 0 10 6"
                        fill="#0d314d"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.85082 4.14324L8.99406 -3.09077e-08L9.70117 0.707107L4.90374 5.50454L4.85082 5.45162L4.79791 5.50454L0.000473945 0.707107L0.707581 -3.93122e-07L4.85082 4.14324Z"
                          fill="#0d314d"
                        />
                      </svg>
                    </div>
                  </Button>
                  <Button
                    display={{ base: "flex", lg: "none" }}
                    justifyContent={"space-between"}
                    borderRadius={{ lg: "20px", base: 0 }}
                    textTransform={"math-auto"}
                    border={"1px solid"}
                    borderColor={"DarkBlue"}
                    fontWeight={"400"}
                    bgColor={"white"}
                    onClick={() => setOpen(!open)}
                    width={{ lg: "222px", base: "100%" }}
                  >
                    Filter
                    <div className="arrow-down">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="7"
                        viewBox="0 0 10 6"
                        fill="#0d314d"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.85082 4.14324L8.99406 -3.09077e-08L9.70117 0.707107L4.90374 5.50454L4.85082 5.45162L4.79791 5.50454L0.000473945 0.707107L0.707581 -3.93122e-07L4.85082 4.14324Z"
                          fill="#0d314d"
                        />
                      </svg>
                    </div>
                  </Button>
                  <Box
                    w={"350px"}
                    left={{ lg: "50%", base: -20 }}
                    transform={"translateX(-50%)"}
                    border={"1px solid #ccc"}
                    boxShadow={"lg"}
                    display={open ? "block" : "none"}
                    pos={"absolute"}
                    top={"50px"}
                    bgColor={"white"}
                    p={4}
                  >
                    <Flex mb={4} alignItems={"center"} gap={4}>
                      <Input
                        type="number"
                        w={"100%"}
                        placeholder="min sqft"
                        borderRadius={"20px"}
                        border={"1px solid"}
                        borderColor={"DarkBlue"}
                        background={"white"}
                        value={min}
                        onChange={(e) => setMin(e.target.value)}
                      />
                      <Text>to</Text>
                      <Input
                        type="number"
                        w={"100%"}
                        placeholder="max sqft"
                        borderRadius={"20px"}
                        border={"1px solid"}
                        borderColor={"DarkBlue"}
                        background={"white"}
                        value={max}
                        onChange={(e) => setMax(e.target.value)}
                      />
                    </Flex>
                    <Flex alignItems={"center"} gap={4}>
                      <Box
                        pos={"relative"}
                        display={{ base: "block", lg: "none" }}
                      >
                        <Select
                          w={"100%"}
                          borderRadius={"20px"}
                          border={"1px solid"}
                          borderColor={"DarkBlue"}
                          background={"white"}
                          value={spaceCondition}
                          onChange={(e) => setSpaceCondition(e.target.value)}
                        >
                          <option value="" selected>
                            Move-In Timing
                          </option>
                          <option value="immediately">Immediately</option>
                          <option value="30days">Within 30 days </option>
                          <option value="3months">3 months</option>
                          <option value="6months">6 months</option>
                          <option value="9months">9 months</option>
                        </Select>
                      </Box>

                      {(spaceCondition || max || min) && (
                        <Box
                          display={{ base: "flex", lg: "none" }}
                          alignItems={"center"}
                          w={"10%"}
                        >
                          <Link
                            onClick={resetSearch}
                            color={"DarkTeal"}
                            textDecorationLine={"underline"}
                          >
                            Reset
                          </Link>
                          {/* <ButtonTheme
                      handleButtonClick={resetSearch}
                      btnText={"Reset"}
                      chakraProps={{
                        w: "100%",
                        bgColor: "white",
                      }}
                    /> */}
                        </Box>
                      )}
                    </Flex>
                  </Box>
                </Box>
                <Box pos={"relative"} display={{ lg: "block", base: "none" }}>
                  <Select
                    w={"100%"}
                    borderRadius={"20px"}
                    border={"1px solid"}
                    borderColor={"DarkBlue"}
                    background={"white"}
                    value={spaceCondition}
                    onChange={(e) => setSpaceCondition(e.target.value)}
                  >
                    <option value="" selected>
                      Move-In Timing
                    </option>
                    <option value="immediately">Immediately</option>
                    <option value="30days">Within 30 days </option>
                    <option value="3months">3 months</option>
                    <option value="6months">6 months</option>
                    <option value="9months">9 months</option>
                  </Select>
                </Box>

                {(spaceCondition || max || min) && (
                  <Box
                    display={{ lg: "flex", base: "none" }}
                    alignItems={"center"}
                    w={"10%"}
                  >
                    <Link
                      onClick={resetSearch}
                      color={"DarkTeal"}
                      textDecorationLine={"underline"}
                    >
                      Reset
                    </Link>
                    {/* <ButtonTheme
                      handleButtonClick={resetSearch}
                      btnText={"Reset"}
                      chakraProps={{
                        w: "100%",
                        bgColor: "white",
                      }}
                    /> */}
                  </Box>
                )}
              </Flex>
            )}
            <Box
              w={"45px"}
              h={"30px"}
              lineHeight={"30px"}
              cursor={"pointer"}
              onClick={() => sethamburger(!hamburger)}
            >
              <Box
                w={"45px"}
                h={"2px"}
                as={"span"}
                pos={"relative"}
                bgColor={
                  isDarkBackground || hamburger || headerScroll
                    ? "white"
                    : "DarkTeal"
                }
                borderRadius={"20px"}
                display={"inline-block"}
                transition={"all .5s ease-in-out"}
                position={"relative"}
                transform={hamburger ? "rotate(45deg)" : "unset"}
                _after={{
                  height: "2px",
                  background:
                    isDarkBackground || hamburger || headerScroll
                      ? "white"
                      : "DarkTeal",
                  borderRadius: "20px",
                  transition: "all .5s ease-in-out",
                  content: '""',
                  position: "absolute",
                  width: "45px",
                  bottom: "10px",
                  right: "0",
                  transform: hamburger
                    ? "rotate(-90deg) translate(-10px,0)"
                    : "unset",
                }}
              ></Box>
            </Box>
          </Flex>
        </Container>
      </Box>
      {window.location.pathname === "/" && (
        <Link
          onClick={gototenant}
          textDecorationLine={"underline"}
          color="#fff"
          overflow={"auto"}
          position={"fixed"}
          right={150}
          top={7}
          display={{ lg: "block", base: "none" }}
          zIndex={"999"}
        >
          Tenant Portal
        </Link>
      )}
      <Box
        bgImage={MenuImg}
        bgSize={"cover"}
        display={"flex"}
        flexDir={"column"}
        justifyContent={"space-around"}
        p={6}
        transition={"all .5s"}
        w={"100%"}
        h={{
          md: headerScroll ? "100vh" : "100vh",
          sm: "100vh",
          //changes
          base: "calc(100vh)",
        }}
        overflow={"auto"}
        position={"fixed"}
        right={"0"}
        bottom={0}
        zIndex={"99"}
        transform={!hamburger ? "translateX(100%)" : "translateX(0px)"}
        backdropFilter="blur(8px)"
        color="white"
        sx={{
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <List
          spacing={4}
          sx={{
            ".chakra-link": {
              cursor: "pointer",
              color: "white",
              fontSize: { md: "4xl", sm: "3xl", base: "2xl" },
            },
          }}
        >
          {HeaderMenu?.map((item) => {
            const isItemActive = () => {
              console.log(item.link === window.location.pathname);
              return item.link === window.location.pathname;
            };
            return (
              <ListItem
                fontFamily={"Larken"}
                key={item?.id}
                fontWeight={"600"}
                paddingStart={{ md: "30%", base: "10%" }}
              >
                <Link
                  target={item?.newTab ? "_blank" : "_self"}
                  _hover={{
                    color: "BrightTurquoise",
                  }}
                  color={isItemActive ? "BrightTurquoise" : "white"}
                  href={item?.link}
                >
                  {item?.title}
                </Link>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
};

export default NewHeader;
